import qs from 'query-string';
import get from 'lodash.get';
import m from 'moment';

import * as params from '../../constants/params';
import { toInt } from '../../utils/primitives';

import { createDeepEqualSelector } from '../utils/selectors';

const selectLocation = ({ router }) => get(router, 'location', {});

export const selectPathname = createDeepEqualSelector(selectLocation, (location) => get(location, 'pathname', ''));

export const selectSearch = createDeepEqualSelector(selectLocation, (location) => get(location, 'search', ''));

export const selectSearchParams = createDeepEqualSelector(selectSearch, (v) => qs.parse(v));

const getParamsAsArr = (collection, key) => {
  const data = get(collection, key, []);

  if (typeof data === 'string') {
    return [data];
  }

  if (!Array.isArray(data)) {
    return [];
  }

  return data;
};

const makeSelectParam = (key, defaultValue = undefined) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => get(searchParams, key, defaultValue));

const makeSelectParams = (key) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => {
    const res = getParamsAsArr(searchParams, key);

    return res;
  });

const makeSelectParamAsInt = (key, defaultValue = undefined) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => toInt(get(searchParams, key, defaultValue)));

const makeSelectParamsAsInt = (key) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => {
    const res = getParamsAsArr(searchParams, key);

    return res.map(toInt);
  });

const makeSelectParamAsTs = (key, defaultValue = undefined) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => {
    const value = get(searchParams, key, defaultValue);
    const d = m.unix(value);

    return d.isValid() ? d.unix() : defaultValue;
  });

const makeSelectParamAsBool = (key, defaultValue = undefined) =>
  createDeepEqualSelector(selectSearchParams, (searchParams) => {
    const value = get(searchParams, key, defaultValue);

    if (value === 'true') {
      return true;
    }

    return false;
  });

export const selectAssets = makeSelectParams(params.ASSET);
export const selectAsset = makeSelectParam(params.ASSET);

export const selectMetricsCodes = makeSelectParams(params.METRIC);
export const selectMetricCode = makeSelectParam(params.METRIC);

export const selectCurrencies = makeSelectParams(params.CURRENCY);
export const selectCurrency = makeSelectParam(params.CURRENCY);

export const selectExchanges = makeSelectParams(params.EXCHANGE);
export const selectExchange = makeSelectParam(params.EXCHANGE);

export const selectMiners = makeSelectParams(params.MINER);
export const selectMiner = makeSelectParam(params.MINER);

export const selectResolutions = makeSelectParams(params.RESOLUTION);
export const selectResolution = makeSelectParam(params.RESOLUTION);

export const selectMovingAverages = makeSelectParamsAsInt(params.MOVING_AVERAGE);
export const selectMovingAverage = makeSelectParamAsInt(params.MOVING_AVERAGE);

export const selectMovingMedians = makeSelectParamsAsInt(params.MOVING_MEDIAN);
export const selectMovingMedian = makeSelectParamAsInt(params.MOVING_MEDIAN);

export const selectMetricsScales = makeSelectParams(params.SCALE_METRIC);
export const selectMetricScale = makeSelectParam(params.SCALE_METRIC);

export const selectPriceScale = makeSelectParam(params.SCALE_PRICE);

export const selectModal = makeSelectParam(params.MODAL);

export const selectDate = makeSelectParam(params.DATE);

export const selectCategory = makeSelectParam(params.CATEGORY, '');

export const selectRedirectTo = makeSelectParam(params.REDIRECT_TO, '');

export const selectZoom = makeSelectParam(params.ZOOM, 'all');

export const selectSecret = makeSelectParam(params.SECRET);

export const selectUpgradePlan = makeSelectParam(params.UPGRADE_PLAN);

export const selectSince = makeSelectParamAsTs(params.SINCE);
export const selectUntil = makeSelectParamAsTs(params.UNTIL);

export const selectSameAxis = makeSelectParamAsBool(params.SAME_AXIS);
export const selectPaymentSuccess = makeSelectParamAsBool(params.PAYMENT_SUCCESS);

export const selectEditDashboard = makeSelectParamAsBool(params.EDIT_DASHBOARD);
